import React from 'react';
import { injectIntl, FormattedMessage } from '../../util/reactIntl';

import {
  AccordionItem,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './FAQPage.module.css';

import illustration from './faq_illustration.png';

const FAQ_NUMBER = 12;

const FAQPage = props => {
  const { intl } = props;
  let faqContentArr = [];
  for (let index = 1; index <= FAQ_NUMBER; index++) {
    faqContentArr.push({
      title: intl.formatMessage({ id: `FAQPage.item${index}.title` }),
      content: intl.formatMessage({ id: `FAQPage.item${index}.content` }),
    });
  }

  return (
    <StaticPage
      title="FAQ"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        name: intl.formatMessage({ id: 'FAQPage.title' }),
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <div className={css.root}>
            <div className={css.header}>
              <FormattedMessage id="FAQPage.title" />
            </div>
            <div className={css.staticPageWrapper}>
              <div className={css.pageContent}>
                <h1 className={css.pageTitle}>
                  <FormattedMessage id="FAQPage.title" />
                </h1>

                <h2 className={css.pageSubtitle}>
                  <FormattedMessage id="FAQPage.subheading" />
                </h2>

                <div className={css.faqBody}>
                  {faqContentArr.map(item => (
                    <AccordionItem key={item.title} title={item.title} content={item.content} />
                  ))}
                </div>

                <img className={css.faqIllustration} src={illustration} />
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default injectIntl(FAQPage);
